<div class="filter">
  <div class="row">
    <div class="col-6">
      <mat-form-field class="filter-field">
        <mat-label class="filter-font">Simulation filter</mat-label>
        <input
          matInput
          name="searchProject"
          (input)="searchChangedEvent()"
          class="filter-text-spacer"
          [formControl]="seachControl"
          [matAutocomplete]="auto"
          #searchInput />
        <mat-icon matPrefix class="filter-icon">search</mat-icon>

        <button
          mat-button
          *ngIf="searchInput.value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="seachControl.reset()"
          (click)="clearInput()">
          <mat-icon>close</mat-icon>
        </button>

        <mat-autocomplete #auto="matAutocomplete">
          <mat-option (click)="optionClicked(searchInput)" *ngFor="let name of filter$ | async" [value]="name">
            {{ name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <div class="col align-self-center d-none d-lg-block" style="text-align: right; margin-top: 3px">
      <mat-checkbox style="margin-right: 50px" (change)="toggleCompare($event.checked)">Compare</mat-checkbox>

      <mat-form-field style="max-width: 180px">
        <mat-label>Status</mat-label>
        <mat-select [value]="filterStatus" (selectionChange)="filterStatusChangedEvent($event.value)" name="status">
          <mat-option value="-">-</mat-option>
          <mat-option value="success">
            <div style="display: inline-block">
              <span class="dot-green"></span>
            </div>

            <div style="display: inline-block; margin-left: 10px">Finished</div>
          </mat-option>
          <mat-option value="processing">
            <div style="display: inline-block">
              <span class="dot-orange"></span>
            </div>

            <div style="display: inline-block; margin-left: 10px">In progress</div>
          </mat-option>
          <mat-option value="failed">
            <div style="display: inline-block">
              <span class="dot-red"></span>
            </div>

            <div style="display: inline-block; margin-left: 10px">Failed</div>
          </mat-option>
          <mat-option value="meshing">
            <div style="display: inline-block">
              <span class="dot-blue"></span>
            </div>

            <div style="display: inline-block; margin-left: 10px">Meshing</div>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-6 d-md-block d-lg-none">
      <mat-checkbox style="position: absolute; top: 60px; right: 35px" (change)="toggleCompare($event.checked)"
        >Compare</mat-checkbox
      >
    </div>

    <div class="col-4 d-none d-md-block d-lg-none">
      <mat-form-field style="margin-top: 30px; max-width: 180px">
        <mat-label>Status</mat-label>
        <mat-select [value]="filterStatus" (selectionChange)="filterStatusChangedEvent($event.value)" name="status">
          <mat-option value="-">-</mat-option>
          <mat-option value="success">
            <div style="display: inline-block">
              <span class="dot-green"></span>
            </div>

            <div style="display: inline-block; margin-left: 10px">Finished</div>
          </mat-option>
          <mat-option value="processing">
            <div style="display: inline-block">
              <span class="dot-orange"></span>
            </div>

            <div style="display: inline-block; margin-left: 10px">In progress</div>
          </mat-option>
          <mat-option value="failed">
            <div style="display: inline-block">
              <span class="dot-red"></span>
            </div>

            <div style="display: inline-block; margin-left: 10px">Failed</div>
          </mat-option>
          <mat-option value="meshing">
            <div style="display: inline-block">
              <span class="dot-blue"></span>
            </div>

            <div style="display: inline-block; margin-left: 10px">Meshing</div>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>
